import { FavoriteSearch } from "@/types";
import { useRef } from "react";
import { useDrag, useDrop } from "react-dnd";
type DragItem = {
  id: string;
  index: number;
};

const DraggableSearch: React.FC<{
  search: FavoriteSearch;
  index: number;
  moveSearch: (dragIndex: number, hoverIndex: number) => void;
}> = ({ search, index, moveSearch }) => {
  const ref = useRef<HTMLDivElement>(null);

  const [, drag] = useDrag({
    type: "SEARCH",
    item: { id: search.id, index },
  });

  const [, drop] = useDrop({
    accept: "SEARCH",
    hover: (item: DragItem) => {
      if (item.index !== index) {
        moveSearch(item.index, index);
        item.index = index;
      }
    },
  });

  drag(drop(ref));

  return (
    <div
      ref={ref}
      className={`cursor-grab w-full truncate text-xs rounded p-1 shrink-0`}
      key={search.id}
    >
      {search.name}
    </div>
  );
};

export default DraggableSearch;
